<template>
  <div class="home" >
    <Header/>
    <Nav :activeTab="ActiveTab" v-on:activeTab="activeTabUpdate" :ModelCount="ModelCount" v-on:ShowForm="ShowFormUpdate"/>
    <SelectedOptions :ModelList="ModelList" v-on:ModelList="ModelListUpdate" :Fueltype="Fueltype" :Geartype="Geartype" :Price="Price" :Transmissiontype="Transmissiontype" v-on:Price="PriceUpdate" v-on:Fueltype="FueltypeUpdate" v-on:Geartypet="GeartypeUpdate" v-on:Transmissiontype="TransmissiontypeUpdate"/>
    <Info v-if="ActiveTab == 0"/>
    <Search :ModelList="ModelList" v-on:ModelList="ModelListUpdate" v-if="ActiveTab == 0"/>
    <SearchEngine  :Fueltype="Fueltype" :Geartype="Geartype" :Transmissiontype="Transmissiontype"  v-on:Fueltype="FueltypeUpdate" v-on:Geartypet="GeartypeUpdate" v-on:Transmissiontype="TransmissiontypeUpdate" v-if="ActiveTab == 1"/>
    <SearchPrice :Price="Price" v-if="ActiveTab == 2" v-on:Price="PriceUpdate"/>
    <Results v-on:ModelName="ModelNameUpdate" v-on:ShowForm="ShowFormUpdate" :ModelList="ModelList" v-on:ModelList="ModelListUpdate" :Fueltype="Fueltype" :Geartype="Geartype" :Price="Price" :Transmissiontype="Transmissiontype" v-on:Price="PriceUpdate" v-on:Fueltype="FueltypeUpdate" v-on:Geartypet="GeartypeUpdate" v-on:Transmissiontype="TransmissiontypeUpdate" v-on:ModelCount="ModelCountUpdate" v-on:pages="pagesUpdate" :page="page"  v-on:page="pageUpdate"/>
    <pagination :page="page" :pages="pages" v-on:page="pageUpdate"/>
    <Footer/>
    <Form :showForm="showForm" :modelName="modelName" v-on:ShowForm="ShowFormUpdate"/>

  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/header.vue'
import HeaderTitle from '@/components/header-title.vue'
import SelectedOptions from '@/components/selected-options.vue'
import Info from '@/components/info.vue'
import Nav from '@/components/nav.vue'
import Search from '@/components/search.vue'
import SearchEngine from '@/components/search-engine.vue'
import SearchPrice from '@/components/search-price.vue'
import Results from '@/components/results.vue'
import Pagination from '@/components/pagination.vue'
import Footer from '@/components/footer.vue'
import Form from '@/components/form.vue'


export default {
  name: 'home',
  components: {
    Header,
    HeaderTitle,
    SelectedOptions,
    Info,
    Nav,
    Search,
    SearchEngine,
    SearchPrice,
    Results,
    Pagination,
    Footer,
    Form
  },
  data: function () {
    return {
      ActiveTab: 0,
      ModelCount: '100+',
      showForm: false,
      page: 1,
      pages:1,
      modelName: '',
      Fueltype: Array(
        {'name':'Diesel','id':'diesel','selected':false},
        {'name':'Benzyna','id':'benzyna','selected':false},
        {'name':'LPG','id':'lpg','selected':false},
        {'name':'Hybryda','id':'hybryda','selected':false}
      ),
      Geartype: Array(
        {'name':'Manualna','id':'manualna','selected':false},
        {'name':'Automatyczna','id':'automatyczna','selected':false},
        // {'name':'Półautomatyczna (ASG, Triptronic)','id':4003,'selected':false},
        // {'name':'Automatyczna bezstopniowa (CVT)','id':4004,'selected':false},
        // {'name':'Automatyczna dwusprzęgłowa (DCT, DSG)','id':4005,'selected':false},
      ),
      Transmissiontype: Array(
        {'name':'Przedni','id':'przedni','selected':false},
        {'name':'Tylny','id':'tylny','selected':false},
        {'name':'4x4','id':'4x4','selected':false},
        // {'name':'4x4 (stały)','id':3004,'selected':false},
        // {'name':'4x4 (dołączany ręcznie)','id':3005,'selected':false},
      ),
      Price: {
        from: {'name':'od 10 000 PLN','value':1000,'selected':false},
        to: {'name':'od 1000 000 PLN','value':1000000,'selected':false},
      },
      ModelList:Array(
          {id: "A1",name: "A1",url: "a1",'selected':false},
          {id: "A3",name: "A3",url: "a3",'selected':false},
          {id: "A4",name: "A4",url: "a4",'selected':false},
          // {id: "A4 Allroad",name: "A4 Allroad",url: "a4-allroad",'selected':false},
          {id: "A5",name: "A5",url: "a5",'selected':false},
          {id: "A6",name: "A6",url: "a6"},
          // {id: "A6 Allroad",name: "A6 Allroad",url: "a6-allroad",'selected':false},
          {id: "A7",name: "A7",url: "a7",'selected':false},
          {id: "A8",name: "A8",url: "a8",'selected':false},
          {id: "Q2",name: "Q2",url: "q2",'selected':false},
          {id: "Q3",name: "Q3",url: "q3",'selected':false},
          {id: "Q5",name: "Q5",url: "q5",'selected':false},
          {id: "Q7",name: "Q7",url: "q7",'selected':false},
          {id: "Q8",name: "Q8",url: "q8"},
          {id: "S3",name: "S3 Limousine",url: "s3",'selected':false},
          // {id: "S6",name: "S6",url: "s6",'selected':false},
          // {id: "S8",name: "S8",url: "s8",'selected':false},
          {id: "SQ7",name: "SQ7",url: "sq7",'selected':false}
        )

    }
  },
  methods: {
    ModelListUpdate (value) {
      this.ModelList = value;
    },
    FueltypeUpdate (value) {
      this.Fueltype = value;
    },
    GeartypeUpdate (value) {
      this.Geartype = value
    },
    TransmissiontypeUpdate (value) {
      this.Transmissiontype= value;
    },
    PriceUpdate (value) {
      this.Price = value;
    },
    ModelCountUpdate (value){
      this.ModelCount = value;
    },
    ShowFormUpdate (value){
      this.showForm = value;
    },
    pagesUpdate (value){
      this.pages = value;
    },
    ModelNameUpdate (value){
      this.modelName = value;
    },
    pageUpdate (value){
      this.page = value;
    },
    activeTabUpdate (value) {
      this.ActiveTab = value;

      var selected = {
          0: 'Strona główna',
          1: 'Silnik i napęd',
          3: 'Cena',
          99:'Wyniki wyszykiwania'
      };

      gtag('event', 'Przełączenie', {
        'event_category': 'Zakładka',
        'event_label': 'Wyświetlenie zakładki '+selected[value],
        'value': selected[value]
      });
    }
  }
}
</script>
